// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import { BiTubeDataFragmentDoc, PlatesDataFragmentDoc, TubeDataFromSessionFragmentDoc, PlatesPriceResponseFragmentDoc, CrisprSessionResponseFragmentDoc, CrisprPriceResponseFragmentDoc, AntiseraSessionDataResponseFragmentDoc, MilliplexSessionDataResponseFragmentDoc, SimpleAntiseraSessionResponseFragmentDoc, NgsoPriceResponseFragmentDoc } from './ConfiguratorTubesQueryFragments.generated';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type SpecificationsQueryVariables = Types.Exact<{
  product: Types.ConfiguratorProductInput;
}>;


export type SpecificationsQuery = { __typename?: 'Query', getSpecifications?: { __typename?: 'Configurations', productDetails?: string | null, specifications: Array<{ __typename?: 'Specifications', categoryName: string, categoryDisplayName: string, specificationModifications?: Array<{ __typename?: 'SpecificationModifications', name: string, displayName: string, value: string }> | null }>, modifications: Array<{ __typename?: 'Modifications', modificationType: string, modificationTypeDisplayName: string, category: Array<{ __typename?: 'Category', categoryName: string, categoryDisplayName?: string | null, order?: string | null, modifications: Array<{ __typename?: 'CategoryModifications', name: string, displayName: string, value: string, order?: string | null, isDefault: string }> }> }> } | null };

export type SpecificationsForCustomCrisprQueryVariables = Types.Exact<{
  product: Types.ConfiguratorProductInput;
}>;


export type SpecificationsForCustomCrisprQuery = { __typename?: 'Query', getSpecificationsForCustomCrispr?: { __typename?: 'Configurations', productDetails?: string | null, specifications: Array<{ __typename?: 'Specifications', categoryName: string, categoryDisplayName: string, specificationModifications?: Array<{ __typename?: 'SpecificationModifications', name: string, displayName: string, value: string }> | null }>, modifications: Array<{ __typename?: 'Modifications', modificationType: string, modificationTypeDisplayName: string, category: Array<{ __typename?: 'Category', categoryName: string, categoryDisplayName?: string | null, order?: string | null, modifications: Array<{ __typename?: 'CategoryModifications', name: string, displayName: string, value: string, order?: string | null, isDefault: string }> }> }> } | null };

export type BitubeDataQueryVariables = Types.Exact<{
  product: Types.ConfiguratorProductInput;
}>;


export type BitubeDataQuery = { __typename?: 'Query', getBitubeData?: { __typename?: 'BiTubeData', data: Array<{ __typename?: 'DuplexDetails', antisenceBaseCount?: number | null, antisenceName?: string | null, antisenceSequence?: string | null, autoGenerateOligo?: boolean | null, customerOverhang?: string | null, customerAntisenseOverHang?: string | null, antisenceThreeMod?: string | null, antisenceFiveMod?: string | null, id?: string | null, oligoId?: number | null, name?: string | null, sequence?: string | null, baseCount?: number | null, threeMod?: string | null, fiveMod?: string | null, format?: string | null, purification?: string | null, concentration?: string | null, countryCode?: string | null, productType?: string | null, scale?: string | null, price?: string | null, tubes?: string | null, autoValidation?: string | null, comments?: string | null, additionalComments?: string | null, applyToAll?: boolean | null, isOverridden?: boolean | null, orderItemId?: string | null, amount?: string | null, senseNameCheck?: boolean | null, cartId?: string | null, itemId?: string | null, currencySymbol?: string | null, currency?: string | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null }> } | null };

export type ModificationsQueryVariables = Types.Exact<{
  product: Types.ConfiguratorProductInput;
}>;


export type ModificationsQuery = { __typename?: 'Query', getModifications?: { __typename?: 'ConfiguratorPlates', modifications: Array<{ __typename?: 'Modifications', modificationType: string, modificationTypeDisplayName: string, category: Array<{ __typename?: 'Category', categoryName: string, order?: string | null, modifications: Array<{ __typename?: 'CategoryModifications', name: string, displayName: string, value: string, order?: string | null, isDefault: string }> }> }> } | null };

export type PlatesSessionDataQueryVariables = Types.Exact<{
  product: Types.ConfiguratorProductInput;
}>;


export type PlatesSessionDataQuery = { __typename?: 'Query', getSessionDataForPlates?: { __typename?: 'PlatesData', data: Array<{ __typename?: 'Plates', isCSR?: boolean | null, isCSRSupervisor?: boolean | null, wellType?: number | null, plateName?: string | null, researcher?: string | null, channelType?: number | null, plateType?: string | null, countryCode?: string | null, totalBaseCount?: number | null, plateId?: number | null, countOfWells?: number | null, material?: string | null, isAmountSelected?: boolean | null, isConcentrationSelected?: boolean | null, purification?: string | null, format?: string | null, concentration?: string | null, amount?: string | null, scale?: string | null, daughterPlateCount?: string | null, isOverridden?: boolean | null, isSpecificationsOverridden?: boolean | null, isShippingOverridden?: boolean | null, isPackageTypeOther?: boolean | null, minAmount?: string | null, maxAmount?: string | null, plateCopiesRange?: string | null, pageNo?: number | null, applyToAll?: boolean | null, researcherNameError?: Array<string | null> | null, plateNameError?: Array<string | null> | null, category?: string | null, packageType?: string | null, shipping?: string | null, stockPlate?: string | null, selectedPackageType?: string | null, productType?: string | null, isConcentrationOther?: boolean | null, wellList: Array<{ __typename?: 'Welllist', id?: number | null, oligoId?: number | null, name?: string | null, wellType?: number | null, mixed?: number | null, sequence?: string | null, baseCount?: number | null, threeMod?: string | null, fiveMod?: string | null, format?: string | null, other?: string | null, purification?: string | null, concentration?: string | null, scale?: string | null, countryCode?: string | null, productType?: string | null, technicalSequence?: string | null, amount?: string | null, tubes?: number | null, terms?: boolean | null, flag?: number | null, row?: string | null, column?: string | null, comments?: string | null, additionalComments?: string | null, isOverridden?: boolean | null, orderItemId?: string | null, pageNo?: number | null, packageType?: string | null, shipping?: string | null, excessMaterial?: boolean | null, molecularWeight?: string | null, primerDimer?: string | null, secondaryStructure?: string | null, gcContent?: string | null, meltingTemparature?: string | null, epsilon?: number | null, price?: string | null, priceHeaderError?: string | null, currency?: string | null, currencySymbol?: string | null, additionalServices?: Array<string | null> | null, listAdditionalServices?: Array<string | null> | null, listNgso?: Array<string | null> | null, ngsoType?: string | null, listISO?: Array<string | null> | null, crossContamination?: string | null, qualitySystem?: string | null, certificateOfAnalysis?: string | null, analyticalHPLC?: string | null, category?: string | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, listWarning?: Array<{ __typename?: 'ListWarning', key?: string | null, value?: string | null } | null> | null }>, biTubeWellList?: Array<{ __typename?: 'BiTubeWellList', antisenceBaseCount?: number | null, antisenceName?: string | null, antisenceSequence?: string | null, autoGenerateOligo?: boolean | null, customerOverhang?: string | null, customerAntisenseOverHang?: string | null, antisenceFiveMod?: string | null, antisenceThreeMod?: string | null, id?: number | null, name?: string | null, sequence?: string | null, baseCount?: number | null, threeMod?: string | null, fiveMod?: string | null, format?: string | null, purification?: string | null, concentration?: string | null, countryCode?: string | null, productType?: string | null, scale?: string | null, tubes?: number | null, autoValidation?: boolean | null, comments?: string | null, additionalComments?: string | null, isOverridden?: boolean | null, orderItemId?: string | null, amount?: string | null, senseNameCheck?: boolean | null, row: string, column: string, technicalAntisenceSequence?: string | null, technicalSequence?: string | null, pageNo?: number | null, packageType?: string | null, shipping?: string | null, terms?: boolean | null, molecularWeight?: string | null, primerDimer?: string | null, secondaryStructure?: string | null, gcContent?: string | null, meltingTemparature?: string | null, antisenseMolecularWeight?: string | null, antisensePrimerDimer?: string | null, antisenseMeltingTemparature?: string | null, antisenseGcContent?: string | null, antisenseSecondaryStructure?: string | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, listWarning?: Array<{ __typename?: 'ListWarning', key?: string | null, value?: string | null } | null> | null } | null> | null }> } | null };

export type GetAntisenceSeqQueryVariables = Types.Exact<{
  seq: Types.Scalars['String']['input'];
  product: Types.ConfiguratorProductInput;
}>;


export type GetAntisenceSeqQuery = { __typename?: 'Query', getAntisenceSeq?: { __typename?: 'AntisenceSeq', antisenceSeq?: string | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null };

export type GetSessionDataQueryVariables = Types.Exact<{
  product: Types.ConfiguratorProductInput;
}>;


export type GetSessionDataQuery = { __typename?: 'Query', getSessionData?: { __typename?: 'TubeDataFromSession', data: Array<{ __typename?: 'TubeSessionData', isOverridden?: boolean | null, name?: string | null, sequence?: string | null, minimumYield?: string | null, epsilon?: number | null, fiveMod?: string | null, threeMod?: string | null, internalMod?: string | null, probeType?: string | null, purification?: string | null, baseCount?: number | null, format?: string | null, scale?: string | null, concentration?: string | null, tubes?: string | null, price?: string | null, orderItemId?: string | null, id?: string | null, applyToAll?: boolean | null, comments?: string | null, additionalComments?: string | null, fullSOligoBackbone?: boolean | null, otherValue?: string | null, nterminalMod?: string | null, cterminalMod?: string | null, fiveModCategory?: string | null, threeModCategory?: string | null, internalModCategory?: string | null, material?: string | null, crossContamination?: string | null, plateType?: string | null, packageType?: string | null, isoCode?: boolean | null, crRnaType?: string | null, customPeptideType?: string | null, sequenceLocation?: string | null, carrierProtein?: string | null, oligoId?: number | null, countryCode?: string | null, autoValidation?: string | null, productType?: string | null, molecularWeight?: string | null, gcContent?: string | null, meltingTemparature?: string | null, primerDimer?: string | null, secondaryStructure?: string | null, currencySymbol?: string | null, currency?: string | null, amount?: string | null, purityLevel?: string | null, quantitation?: string | null, isLabelledAminoAcid?: boolean | null, cartId?: string | null, itemId?: string | null, conjugation?: string | null, conjugationAmount?: string | null, conjugationChemistry?: string | null, additionalCarrierProtein?: string | null, additionalServices?: Array<string | null> | null, flag?: number | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null }> } | null };

export type SpecificationCalculationQueryVariables = Types.Exact<{
  input: Types.SpecificationsInput;
  product: Types.ConfiguratorProductInput;
}>;


export type SpecificationCalculationQuery = { __typename?: 'Query', getSpecificationCalculation?: { __typename?: 'SpecificationsResponse', errorValues?: Array<{ __typename?: 'ErrorValues', valid?: string | null, validationType?: string | null, key?: string | null } | null> | null, calculatedValues?: { __typename?: 'CalculatedValues', amount?: string | null, maxConcentration?: number | null, scale?: string | null, daughterPlateRange?: number | null, maxAmount?: number | null, maxVolume?: number | null, minVolume?: number | null } | null } | null };

export type GetPlatePriceCallQueryVariables = Types.Exact<{
  product: Types.ConfiguratorProductInput;
}>;


export type GetPlatePriceCallQuery = { __typename?: 'Query', getPlatePriceCall?: { __typename?: 'PlatesPriceResponse', response?: Array<{ __typename?: 'PlatePrice', currency?: string | null, brand?: string | null, material?: string | null, currencySymbol?: string | null, baseFee?: string | null, modificationFee?: string | null, purificationFee?: string | null, plateCopyFee?: string | null, shippingOptionFee?: string | null, remainingMaterials?: string | null, plateId?: number | null, plateName?: string | null, totalPrice?: string | null, errorType?: string | null, priceErrorHeader?: string | null, plateFee?: string | null, processFee?: string | null, wells?: string | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null };

export type GetProductInformationQueryVariables = Types.Exact<{
  input: Types.GetProductInformationInput;
}>;


export type GetProductInformationQuery = { __typename?: 'Query', getProductInformation?: { __typename?: 'ProductInformationResponse', productType?: string | null, typeCode?: string | null, packageType?: string | null, instructions?: string | null, displayName?: string | null, brand?: string | null, shippingOptions?: Array<string | null> | null, companionProducts?: Array<string | null> | null, currencyFormat?: string | null, decimalSeparator?: string | null, thousandSeparator?: string | null, prefixCurrecny?: boolean | null, thousandSpacing?: string | null } | null };

export type TubeEditLinkQueryVariables = Types.Exact<{
  product?: Types.InputMaybe<Types.TubeEditInput>;
}>;


export type TubeEditLinkQuery = { __typename?: 'Query', tubeEditLink?: { __typename?: 'TubeDataFromSession', data: Array<{ __typename?: 'TubeSessionData', isOverridden?: boolean | null, name?: string | null, sequence?: string | null, minimumYield?: string | null, epsilon?: number | null, fiveMod?: string | null, threeMod?: string | null, internalMod?: string | null, probeType?: string | null, purification?: string | null, baseCount?: number | null, format?: string | null, scale?: string | null, concentration?: string | null, tubes?: string | null, price?: string | null, orderItemId?: string | null, id?: string | null, applyToAll?: boolean | null, comments?: string | null, additionalComments?: string | null, fullSOligoBackbone?: boolean | null, otherValue?: string | null, nterminalMod?: string | null, cterminalMod?: string | null, fiveModCategory?: string | null, threeModCategory?: string | null, internalModCategory?: string | null, material?: string | null, crossContamination?: string | null, plateType?: string | null, packageType?: string | null, isoCode?: boolean | null, crRnaType?: string | null, customPeptideType?: string | null, sequenceLocation?: string | null, carrierProtein?: string | null, oligoId?: number | null, countryCode?: string | null, autoValidation?: string | null, productType?: string | null, molecularWeight?: string | null, gcContent?: string | null, meltingTemparature?: string | null, primerDimer?: string | null, secondaryStructure?: string | null, currencySymbol?: string | null, currency?: string | null, amount?: string | null, purityLevel?: string | null, quantitation?: string | null, isLabelledAminoAcid?: boolean | null, cartId?: string | null, itemId?: string | null, conjugation?: string | null, conjugationAmount?: string | null, conjugationChemistry?: string | null, additionalCarrierProtein?: string | null, additionalServices?: Array<string | null> | null, flag?: number | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null }> } | null };

export type GetCrisprSessionDataQueryVariables = Types.Exact<{
  product: Types.ConfiguratorProductInput;
}>;


export type GetCrisprSessionDataQuery = { __typename?: 'Query', getCrisprSessionData?: { __typename?: 'CrisprSessionResponse', data: Array<{ __typename?: 'CrisprSessionData', id?: number | null, isOverridden?: boolean | null, productType?: string | null, physicalMaterial?: string | null, listPhysicalMaterials?: Array<string | null> | null, listLentiviralBackbones?: Array<string | null> | null, listViralTiters?: Array<string | null> | null, listVolumes?: Array<string | null> | null, listAliquotings?: Array<string | null> | null, listVectors?: Array<string | null> | null, listAmount?: Array<string | null> | null, listSpecies?: Array<string | null> | null, listPurification?: Array<string | null> | null, listScale?: Array<string | null> | null, listModification?: Array<string | null> | null, listStructure?: Array<string | null> | null, lentiviralBackbone?: string | null, vector?: string | null, viralTiter?: string | null, volume?: string | null, aliquoting?: string | null, amount?: string | null, pageNo?: number | null, scale?: string | null, purification?: string | null, format?: string | null, modification?: string | null, species?: string | null, structure?: string | null, price?: string | null, currencySymbol?: string | null, currency?: string | null, terms?: boolean | null, material?: string | null, cartId?: string | null, itemId?: string | null, modifiedSequence?: string | null, modifiedTechnicalSequence?: string | null, mergedSession?: boolean | null, listSubModels?: Array<{ __typename?: 'ListSubModel', name?: string | null, geneId?: string | null, geneSymbol?: string | null, sequence?: string | null, id?: number | null, isOverridden?: boolean | null, isCurrentForm?: boolean | null, baseCount?: number | null, price?: string | null, cartId?: string | null, itemId?: string | null, listSubModelErrors?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null }> } | null };

export type MilliplexSearchAnalytesQueryVariables = Types.Exact<{
  input: Types.Scalars['String']['input'];
  product: Types.ConfiguratorProductInput;
}>;


export type MilliplexSearchAnalytesQuery = { __typename?: 'Query', milliplexSearchAnalytes?: { __typename?: 'MilliplexSearchResponse', requestDate?: string | null, responseDate?: string | null, count?: number | null, version?: string | null, term?: Array<string | null> | null, termCount?: string | null, assays?: Array<{ __typename?: 'KitsItem', panelId?: string | null, panelName?: string | null, assayType?: string | null, customPremixedAvailable?: Array<string | null> | null, requireSample?: string | null, researchAreaOracle?: Array<string | null> | null, species?: string | null, researchAreas?: Array<string | null> | null, type?: string | null, listSampleType?: Array<string | null> | null, customPremixSelection?: string | null, spaceSaverSelection?: string | null, decisionTableVer?: string | null, listAnalytes?: Array<string | null> | null, selectedAnalytes?: Array<string | null> | null, price?: string | null, allAnalytesSelected?: string | null, mutualAnalytesList?: Array<Array<string | null> | null> | null, analytes?: Array<string | null> | null, quantity?: string | null, material?: string | null, spaceSaver?: string | null, name?: string | null, sampleType?: string | null, id?: number | null, productTotal?: string | null, listSearchResultModelErrors?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, listWarnings?: Array<{ __typename?: 'ListWarning', key?: string | null, value?: string | null } | null> | null } | null> | null } | null };

export type GetCrisprPriceCallQueryVariables = Types.Exact<{
  product: Types.ConfiguratorProductInput;
}>;


export type GetCrisprPriceCallQuery = { __typename?: 'Query', getCrisprPriceCall?: { __typename?: 'CrisprPriceResponse', response?: Array<{ __typename?: 'CrisprPrice', currencySymbol?: string | null, price?: string | null, currency?: string | null, brand?: string | null, material?: string | null, listSubModels?: Array<{ __typename?: 'ListSubModel', price?: string | null } | null> | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null };

export type GetAntiseraSessionDataQueryVariables = Types.Exact<{
  product: Types.ConfiguratorProductInput;
}>;


export type GetAntiseraSessionDataQuery = { __typename?: 'Query', getAntiseraSessionData?: { __typename?: 'AntiseraSessionDataResponse', antiseraData?: Array<{ __typename?: 'AntiseraSessionData', id?: string | null, oligoId?: number | null, name?: string | null, countryCode?: string | null, productType?: string | null, projectName?: string | null, animalType?: string | null, numberOfAnimals?: string | null, immunizationTerm?: string | null, elisaAnalysis?: string | null, columnConstruction?: string | null, noOfColumns?: string | null, purificationOption?: string | null, purificationType?: string | null, absorptionType?: string | null, purificationColumn?: string | null, numberOfPeptides?: string | null, firstName?: string | null, lastName?: string | null, orgName?: string | null, email?: string | null, phone?: string | null, projectType?: string | null, peptide?: string | null, purificationColQuantity?: string | null, absorption?: string | null, absorptionColQuantity?: string | null, absorptionColumn?: string | null, additionalServices?: Array<string | null> | null, comments?: string | null, listAntigenForColumn?: Array<Array<string | null> | null> | null, applyToAll?: boolean | null, cartId?: string | null, itemId?: string | null, currency?: string | null, currencySymbol?: string | null, price?: string | null, projectBaseFee?: string | null, elisaFee?: string | null, colConstructionFee?: string | null, purificationFee?: string | null, adsorptionFee?: string | null, subtotal?: string | null, listAntiseraPeptideModel: Array<{ __typename?: 'AntiseraPeptideModelResponse', peptideName?: string | null, id?: string | null, amount?: string | null, sequence?: string | null, baseCount?: number | null, nterminalMod?: string | null, cterminalMod?: string | null, purityLevel?: string | null, peptideCarrierProtein?: string | null, peptideAddSpecification?: string | null, terms?: boolean | null, projectType?: string | null, listPeptideCarrierProtein?: Array<string | null> | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null>, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null } | null };

export type GetMilliplexSessionDataQueryVariables = Types.Exact<{
  product: Types.ConfiguratorProductInput;
}>;


export type GetMilliplexSessionDataQuery = { __typename?: 'Query', getMilliplexSessionData?: { __typename?: 'MilliplexSessionDataResponse', milliplexData?: Array<{ __typename?: 'MilliplexSessionData', priceHeaderError?: string | null, currencySymbol?: string | null, brand?: string | null, currency?: string | null, sensitivity?: string | null, analytes?: Array<string | null> | null, mapMates?: string | null, errors?: Array<string | null> | null, species?: string | null, platform?: string | null, singlePlexPlatform?: Array<string | null> | null, researchAreas?: Array<string | null> | null, sampleVolume?: Array<string | null> | null, attributes?: Array<string | null> | null, checkedProductIdList?: Array<string | null> | null, productType?: string | null, milliplexcheckedProductIdList?: Array<string | null> | null, oligoId?: number | null, id?: number | null, listMilliplexAssayModel?: Array<{ __typename?: 'MilliplexSearchResponse', requestDate?: string | null, responseDate?: string | null, count?: number | null, version?: string | null, term?: Array<string | null> | null, termCount?: string | null, assays?: Array<{ __typename?: 'KitsItem', panelId?: string | null, panelName?: string | null, assayType?: string | null, customPremixedAvailable?: Array<string | null> | null, requireSample?: string | null, researchAreaOracle?: Array<string | null> | null, species?: string | null, researchAreas?: Array<string | null> | null, type?: string | null, listSampleType?: Array<string | null> | null, customPremixSelection?: string | null, spaceSaverSelection?: string | null, decisionTableVer?: string | null, listAnalytes?: Array<string | null> | null, selectedAnalytes?: Array<string | null> | null, price?: string | null, allAnalytesSelected?: string | null, mutualAnalytesList?: Array<Array<string | null> | null> | null, analytes?: Array<string | null> | null, quantity?: string | null, material?: string | null, spaceSaver?: string | null, name?: string | null, sampleType?: string | null, id?: number | null, productTotal?: string | null, listSearchResultModelErrors?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null, listWarnings?: Array<{ __typename?: 'ListWarning', key?: string | null, value?: string | null } | null> | null } | null> | null } | null> | null } | null> | null } | null };

export type GetSimpleAntiseraSessionDataQueryVariables = Types.Exact<{
  product: Types.ConfiguratorProductInput;
}>;


export type GetSimpleAntiseraSessionDataQuery = { __typename?: 'Query', getSimpleAntiseraSessionData?: { __typename?: 'SimpleAntiseraSessionResponse', simpleAntiseraData?: Array<{ __typename?: 'SimpleAntiseraSessionData', id?: string | null, oligoId?: number | null, name?: string | null, countryCode?: string | null, productType?: string | null, projectName?: string | null, animalType?: string | null, numberOfAnimals?: string | null, immunizationTerm?: string | null, elisaAnalysis?: string | null, columnConstruction?: string | null, noOfColumns?: string | null, purificationType?: string | null, purificationColumn?: string | null, additionalServices?: Array<string | null> | null, purificationOption?: string | null, listAntigenForColumn?: Array<Array<string | null> | null> | null, comments?: string | null, currencySymbol?: string | null, price?: string | null, currency?: string | null, projectBaseFee?: string | null, elisaFee?: string | null, colConstructionFee?: string | null, purificationFee?: string | null, subtotal?: string | null, numberOfPeptides?: string | null, cartId?: string | null, itemId?: string | null, listAntiseraPeptideModel?: Array<{ __typename?: 'AntiseraPeptideModelResponse', peptideName?: string | null, id?: string | null, amount?: string | null, sequence?: string | null, baseCount?: number | null, nterminalMod?: string | null, cterminalMod?: string | null, purityLevel?: string | null, peptideCarrierProtein?: string | null, peptideAddSpecification?: string | null, terms?: boolean | null, projectType?: string | null, listPeptideCarrierProtein?: Array<string | null> | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null } | null };

export type BitubeEditLinkQueryVariables = Types.Exact<{
  product?: Types.InputMaybe<Types.TubeEditInput>;
}>;


export type BitubeEditLinkQuery = { __typename?: 'Query', bitubeEditLink?: { __typename?: 'BiTubeData', data: Array<{ __typename?: 'DuplexDetails', antisenceBaseCount?: number | null, antisenceName?: string | null, antisenceSequence?: string | null, autoGenerateOligo?: boolean | null, customerOverhang?: string | null, customerAntisenseOverHang?: string | null, antisenceThreeMod?: string | null, antisenceFiveMod?: string | null, id?: string | null, oligoId?: number | null, name?: string | null, sequence?: string | null, baseCount?: number | null, threeMod?: string | null, fiveMod?: string | null, format?: string | null, purification?: string | null, concentration?: string | null, countryCode?: string | null, productType?: string | null, scale?: string | null, price?: string | null, tubes?: string | null, autoValidation?: string | null, comments?: string | null, additionalComments?: string | null, applyToAll?: boolean | null, isOverridden?: boolean | null, orderItemId?: string | null, amount?: string | null, senseNameCheck?: boolean | null, cartId?: string | null, itemId?: string | null, currencySymbol?: string | null, currency?: string | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null }> } | null };

export type GetConfContactDetailsQueryVariables = Types.Exact<{
  country?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetConfContactDetailsQuery = { __typename?: 'Query', getConfContactDetails?: { __typename?: 'ConfContactDetailsResponse', phone?: string | null, email?: string | null } | null };

export type CustomCrisprEditLinkQueryVariables = Types.Exact<{
  product: Types.ConfiguratorProductInput;
}>;


export type CustomCrisprEditLinkQuery = { __typename?: 'Query', customCrisprEditLink?: { __typename?: 'CrisprSessionResponse', data: Array<{ __typename?: 'CrisprSessionData', id?: number | null, isOverridden?: boolean | null, productType?: string | null, physicalMaterial?: string | null, listPhysicalMaterials?: Array<string | null> | null, listLentiviralBackbones?: Array<string | null> | null, listViralTiters?: Array<string | null> | null, listVolumes?: Array<string | null> | null, listAliquotings?: Array<string | null> | null, listVectors?: Array<string | null> | null, listAmount?: Array<string | null> | null, listSpecies?: Array<string | null> | null, listPurification?: Array<string | null> | null, listScale?: Array<string | null> | null, listModification?: Array<string | null> | null, listStructure?: Array<string | null> | null, lentiviralBackbone?: string | null, vector?: string | null, viralTiter?: string | null, volume?: string | null, aliquoting?: string | null, amount?: string | null, pageNo?: number | null, scale?: string | null, purification?: string | null, format?: string | null, modification?: string | null, species?: string | null, structure?: string | null, price?: string | null, currencySymbol?: string | null, currency?: string | null, terms?: boolean | null, material?: string | null, cartId?: string | null, itemId?: string | null, modifiedSequence?: string | null, modifiedTechnicalSequence?: string | null, mergedSession?: boolean | null, listSubModels?: Array<{ __typename?: 'ListSubModel', name?: string | null, geneId?: string | null, geneSymbol?: string | null, sequence?: string | null, id?: number | null, isOverridden?: boolean | null, isCurrentForm?: boolean | null, baseCount?: number | null, price?: string | null, cartId?: string | null, itemId?: string | null, listSubModelErrors?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null }> } | null };

export type SimpleAntiseraEditLinkQueryVariables = Types.Exact<{
  product: Types.ConfiguratorProductInput;
}>;


export type SimpleAntiseraEditLinkQuery = { __typename?: 'Query', simpleAntiseraEditLink?: { __typename?: 'SimpleAntiseraSessionResponse', simpleAntiseraData?: Array<{ __typename?: 'SimpleAntiseraSessionData', id?: string | null, oligoId?: number | null, name?: string | null, countryCode?: string | null, productType?: string | null, projectName?: string | null, animalType?: string | null, numberOfAnimals?: string | null, immunizationTerm?: string | null, elisaAnalysis?: string | null, columnConstruction?: string | null, noOfColumns?: string | null, purificationType?: string | null, purificationColumn?: string | null, additionalServices?: Array<string | null> | null, purificationOption?: string | null, listAntigenForColumn?: Array<Array<string | null> | null> | null, comments?: string | null, currencySymbol?: string | null, price?: string | null, currency?: string | null, projectBaseFee?: string | null, elisaFee?: string | null, colConstructionFee?: string | null, purificationFee?: string | null, subtotal?: string | null, numberOfPeptides?: string | null, cartId?: string | null, itemId?: string | null, listAntiseraPeptideModel?: Array<{ __typename?: 'AntiseraPeptideModelResponse', peptideName?: string | null, id?: string | null, amount?: string | null, sequence?: string | null, baseCount?: number | null, nterminalMod?: string | null, cterminalMod?: string | null, purityLevel?: string | null, peptideCarrierProtein?: string | null, peptideAddSpecification?: string | null, terms?: boolean | null, projectType?: string | null, listPeptideCarrierProtein?: Array<string | null> | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null } | null };

export type AntiseraEditLinkQueryVariables = Types.Exact<{
  product: Types.ConfiguratorProductInput;
}>;


export type AntiseraEditLinkQuery = { __typename?: 'Query', antiseraEditLink?: { __typename?: 'AntiseraSessionDataResponse', antiseraData?: Array<{ __typename?: 'AntiseraSessionData', id?: string | null, oligoId?: number | null, name?: string | null, countryCode?: string | null, productType?: string | null, projectName?: string | null, animalType?: string | null, numberOfAnimals?: string | null, immunizationTerm?: string | null, elisaAnalysis?: string | null, columnConstruction?: string | null, noOfColumns?: string | null, purificationOption?: string | null, purificationType?: string | null, absorptionType?: string | null, purificationColumn?: string | null, numberOfPeptides?: string | null, firstName?: string | null, lastName?: string | null, orgName?: string | null, email?: string | null, phone?: string | null, projectType?: string | null, peptide?: string | null, purificationColQuantity?: string | null, absorption?: string | null, absorptionColQuantity?: string | null, absorptionColumn?: string | null, additionalServices?: Array<string | null> | null, comments?: string | null, listAntigenForColumn?: Array<Array<string | null> | null> | null, applyToAll?: boolean | null, cartId?: string | null, itemId?: string | null, currency?: string | null, currencySymbol?: string | null, price?: string | null, projectBaseFee?: string | null, elisaFee?: string | null, colConstructionFee?: string | null, purificationFee?: string | null, adsorptionFee?: string | null, subtotal?: string | null, listAntiseraPeptideModel: Array<{ __typename?: 'AntiseraPeptideModelResponse', peptideName?: string | null, id?: string | null, amount?: string | null, sequence?: string | null, baseCount?: number | null, nterminalMod?: string | null, cterminalMod?: string | null, purityLevel?: string | null, peptideCarrierProtein?: string | null, peptideAddSpecification?: string | null, terms?: boolean | null, projectType?: string | null, listPeptideCarrierProtein?: Array<string | null> | null, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null>, listError?: Array<{ __typename?: 'ListError', key?: string | null, value?: string | null } | null> | null } | null> | null } | null };

export type GetCustomOligoProductsQueryVariables = Types.Exact<{
  input: Types.ConfiguratorProductInput;
}>;


export type GetCustomOligoProductsQuery = { __typename?: 'Query', getCustomOligoProducts?: { __typename?: 'CustomOligoProductResponse', products?: Array<string | null> | null } | null };

export type GetNgsoPriceCallQueryVariables = Types.Exact<{
  product: Types.ConfiguratorProductInput;
}>;


export type GetNgsoPriceCallQuery = { __typename?: 'Query', getNgsoPriceCall?: { __typename?: 'NgsoPriceResponse', response?: Array<{ __typename?: 'NgsoPlatePrice', countryCode?: string | null, productType?: string | null, plateId?: number | null, material?: string | null, pageNo?: number | null, wellList?: Array<{ __typename?: 'WellListPrice', id?: number | null, oligoId?: number | null, name?: string | null, sequence?: string | null, baseCount?: string | null, shipping?: string | null, priceHeaderError?: string | null, price?: string | null, currencySymbol?: string | null, currency?: string | null, formattedPrice?: string | null, brand?: string | null, material?: string | null } | null> | null } | null> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } | null };


export const SpecificationsDocument = gql`
    query specifications($product: ConfiguratorProductInput!) {
  getSpecifications(product: $product) {
    productDetails
    specifications {
      categoryName
      categoryDisplayName
      specificationModifications {
        name
        displayName
        value
      }
    }
    modifications {
      modificationType
      modificationTypeDisplayName
      category {
        categoryName
        categoryDisplayName
        order
        modifications {
          name
          displayName
          value
          order
          isDefault
        }
      }
    }
  }
}
    `;
export type SpecificationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SpecificationsQuery, SpecificationsQueryVariables>, 'query'> & ({ variables: SpecificationsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SpecificationsComponent = (props: SpecificationsComponentProps) => (
      <ApolloReactComponents.Query<SpecificationsQuery, SpecificationsQueryVariables> query={SpecificationsDocument} {...props} />
    );
    

/**
 * __useSpecificationsQuery__
 *
 * To run a query within a React component, call `useSpecificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecificationsQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useSpecificationsQuery(baseOptions: Apollo.QueryHookOptions<SpecificationsQuery, SpecificationsQueryVariables> & ({ variables: SpecificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpecificationsQuery, SpecificationsQueryVariables>(SpecificationsDocument, options);
      }
export function useSpecificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpecificationsQuery, SpecificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpecificationsQuery, SpecificationsQueryVariables>(SpecificationsDocument, options);
        }
export function useSpecificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SpecificationsQuery, SpecificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SpecificationsQuery, SpecificationsQueryVariables>(SpecificationsDocument, options);
        }
export type SpecificationsQueryHookResult = ReturnType<typeof useSpecificationsQuery>;
export type SpecificationsLazyQueryHookResult = ReturnType<typeof useSpecificationsLazyQuery>;
export type SpecificationsSuspenseQueryHookResult = ReturnType<typeof useSpecificationsSuspenseQuery>;
export type SpecificationsQueryResult = Apollo.QueryResult<SpecificationsQuery, SpecificationsQueryVariables>;
export const SpecificationsForCustomCrisprDocument = gql`
    query specificationsForCustomCrispr($product: ConfiguratorProductInput!) {
  getSpecificationsForCustomCrispr(product: $product) {
    productDetails
    specifications {
      categoryName
      categoryDisplayName
      specificationModifications {
        name
        displayName
        value
      }
    }
    modifications {
      modificationType
      modificationTypeDisplayName
      category {
        categoryName
        categoryDisplayName
        order
        modifications {
          name
          displayName
          value
          order
          isDefault
        }
      }
    }
  }
}
    `;
export type SpecificationsForCustomCrisprComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SpecificationsForCustomCrisprQuery, SpecificationsForCustomCrisprQueryVariables>, 'query'> & ({ variables: SpecificationsForCustomCrisprQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SpecificationsForCustomCrisprComponent = (props: SpecificationsForCustomCrisprComponentProps) => (
      <ApolloReactComponents.Query<SpecificationsForCustomCrisprQuery, SpecificationsForCustomCrisprQueryVariables> query={SpecificationsForCustomCrisprDocument} {...props} />
    );
    

/**
 * __useSpecificationsForCustomCrisprQuery__
 *
 * To run a query within a React component, call `useSpecificationsForCustomCrisprQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecificationsForCustomCrisprQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecificationsForCustomCrisprQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useSpecificationsForCustomCrisprQuery(baseOptions: Apollo.QueryHookOptions<SpecificationsForCustomCrisprQuery, SpecificationsForCustomCrisprQueryVariables> & ({ variables: SpecificationsForCustomCrisprQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpecificationsForCustomCrisprQuery, SpecificationsForCustomCrisprQueryVariables>(SpecificationsForCustomCrisprDocument, options);
      }
export function useSpecificationsForCustomCrisprLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpecificationsForCustomCrisprQuery, SpecificationsForCustomCrisprQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpecificationsForCustomCrisprQuery, SpecificationsForCustomCrisprQueryVariables>(SpecificationsForCustomCrisprDocument, options);
        }
export function useSpecificationsForCustomCrisprSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SpecificationsForCustomCrisprQuery, SpecificationsForCustomCrisprQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SpecificationsForCustomCrisprQuery, SpecificationsForCustomCrisprQueryVariables>(SpecificationsForCustomCrisprDocument, options);
        }
export type SpecificationsForCustomCrisprQueryHookResult = ReturnType<typeof useSpecificationsForCustomCrisprQuery>;
export type SpecificationsForCustomCrisprLazyQueryHookResult = ReturnType<typeof useSpecificationsForCustomCrisprLazyQuery>;
export type SpecificationsForCustomCrisprSuspenseQueryHookResult = ReturnType<typeof useSpecificationsForCustomCrisprSuspenseQuery>;
export type SpecificationsForCustomCrisprQueryResult = Apollo.QueryResult<SpecificationsForCustomCrisprQuery, SpecificationsForCustomCrisprQueryVariables>;
export const BitubeDataDocument = gql`
    query bitubeData($product: ConfiguratorProductInput!) {
  getBitubeData(product: $product) {
    ...BiTubeData
  }
}
    ${BiTubeDataFragmentDoc}`;
export type BitubeDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BitubeDataQuery, BitubeDataQueryVariables>, 'query'> & ({ variables: BitubeDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BitubeDataComponent = (props: BitubeDataComponentProps) => (
      <ApolloReactComponents.Query<BitubeDataQuery, BitubeDataQueryVariables> query={BitubeDataDocument} {...props} />
    );
    

/**
 * __useBitubeDataQuery__
 *
 * To run a query within a React component, call `useBitubeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBitubeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBitubeDataQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useBitubeDataQuery(baseOptions: Apollo.QueryHookOptions<BitubeDataQuery, BitubeDataQueryVariables> & ({ variables: BitubeDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BitubeDataQuery, BitubeDataQueryVariables>(BitubeDataDocument, options);
      }
export function useBitubeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BitubeDataQuery, BitubeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BitubeDataQuery, BitubeDataQueryVariables>(BitubeDataDocument, options);
        }
export function useBitubeDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BitubeDataQuery, BitubeDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BitubeDataQuery, BitubeDataQueryVariables>(BitubeDataDocument, options);
        }
export type BitubeDataQueryHookResult = ReturnType<typeof useBitubeDataQuery>;
export type BitubeDataLazyQueryHookResult = ReturnType<typeof useBitubeDataLazyQuery>;
export type BitubeDataSuspenseQueryHookResult = ReturnType<typeof useBitubeDataSuspenseQuery>;
export type BitubeDataQueryResult = Apollo.QueryResult<BitubeDataQuery, BitubeDataQueryVariables>;
export const ModificationsDocument = gql`
    query modifications($product: ConfiguratorProductInput!) {
  getModifications(product: $product) {
    modifications {
      modificationType
      modificationTypeDisplayName
      category {
        categoryName
        order
        modifications {
          name
          displayName
          value
          order
          isDefault
        }
      }
    }
  }
}
    `;
export type ModificationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ModificationsQuery, ModificationsQueryVariables>, 'query'> & ({ variables: ModificationsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ModificationsComponent = (props: ModificationsComponentProps) => (
      <ApolloReactComponents.Query<ModificationsQuery, ModificationsQueryVariables> query={ModificationsDocument} {...props} />
    );
    

/**
 * __useModificationsQuery__
 *
 * To run a query within a React component, call `useModificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModificationsQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useModificationsQuery(baseOptions: Apollo.QueryHookOptions<ModificationsQuery, ModificationsQueryVariables> & ({ variables: ModificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModificationsQuery, ModificationsQueryVariables>(ModificationsDocument, options);
      }
export function useModificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModificationsQuery, ModificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModificationsQuery, ModificationsQueryVariables>(ModificationsDocument, options);
        }
export function useModificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ModificationsQuery, ModificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModificationsQuery, ModificationsQueryVariables>(ModificationsDocument, options);
        }
export type ModificationsQueryHookResult = ReturnType<typeof useModificationsQuery>;
export type ModificationsLazyQueryHookResult = ReturnType<typeof useModificationsLazyQuery>;
export type ModificationsSuspenseQueryHookResult = ReturnType<typeof useModificationsSuspenseQuery>;
export type ModificationsQueryResult = Apollo.QueryResult<ModificationsQuery, ModificationsQueryVariables>;
export const PlatesSessionDataDocument = gql`
    query platesSessionData($product: ConfiguratorProductInput!) {
  getSessionDataForPlates(product: $product) {
    ...PlatesData
  }
}
    ${PlatesDataFragmentDoc}`;
export type PlatesSessionDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PlatesSessionDataQuery, PlatesSessionDataQueryVariables>, 'query'> & ({ variables: PlatesSessionDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PlatesSessionDataComponent = (props: PlatesSessionDataComponentProps) => (
      <ApolloReactComponents.Query<PlatesSessionDataQuery, PlatesSessionDataQueryVariables> query={PlatesSessionDataDocument} {...props} />
    );
    

/**
 * __usePlatesSessionDataQuery__
 *
 * To run a query within a React component, call `usePlatesSessionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatesSessionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatesSessionDataQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function usePlatesSessionDataQuery(baseOptions: Apollo.QueryHookOptions<PlatesSessionDataQuery, PlatesSessionDataQueryVariables> & ({ variables: PlatesSessionDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatesSessionDataQuery, PlatesSessionDataQueryVariables>(PlatesSessionDataDocument, options);
      }
export function usePlatesSessionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlatesSessionDataQuery, PlatesSessionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatesSessionDataQuery, PlatesSessionDataQueryVariables>(PlatesSessionDataDocument, options);
        }
export function usePlatesSessionDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatesSessionDataQuery, PlatesSessionDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlatesSessionDataQuery, PlatesSessionDataQueryVariables>(PlatesSessionDataDocument, options);
        }
export type PlatesSessionDataQueryHookResult = ReturnType<typeof usePlatesSessionDataQuery>;
export type PlatesSessionDataLazyQueryHookResult = ReturnType<typeof usePlatesSessionDataLazyQuery>;
export type PlatesSessionDataSuspenseQueryHookResult = ReturnType<typeof usePlatesSessionDataSuspenseQuery>;
export type PlatesSessionDataQueryResult = Apollo.QueryResult<PlatesSessionDataQuery, PlatesSessionDataQueryVariables>;
export const GetAntisenceSeqDocument = gql`
    query getAntisenceSeq($seq: String!, $product: ConfiguratorProductInput!) {
  getAntisenceSeq(seq: $seq, product: $product) {
    antisenceSeq
    serverError {
      key
      value
    }
  }
}
    `;
export type GetAntisenceSeqComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAntisenceSeqQuery, GetAntisenceSeqQueryVariables>, 'query'> & ({ variables: GetAntisenceSeqQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAntisenceSeqComponent = (props: GetAntisenceSeqComponentProps) => (
      <ApolloReactComponents.Query<GetAntisenceSeqQuery, GetAntisenceSeqQueryVariables> query={GetAntisenceSeqDocument} {...props} />
    );
    

/**
 * __useGetAntisenceSeqQuery__
 *
 * To run a query within a React component, call `useGetAntisenceSeqQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAntisenceSeqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAntisenceSeqQuery({
 *   variables: {
 *      seq: // value for 'seq'
 *      product: // value for 'product'
 *   },
 * });
 */
export function useGetAntisenceSeqQuery(baseOptions: Apollo.QueryHookOptions<GetAntisenceSeqQuery, GetAntisenceSeqQueryVariables> & ({ variables: GetAntisenceSeqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAntisenceSeqQuery, GetAntisenceSeqQueryVariables>(GetAntisenceSeqDocument, options);
      }
export function useGetAntisenceSeqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAntisenceSeqQuery, GetAntisenceSeqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAntisenceSeqQuery, GetAntisenceSeqQueryVariables>(GetAntisenceSeqDocument, options);
        }
export function useGetAntisenceSeqSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAntisenceSeqQuery, GetAntisenceSeqQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAntisenceSeqQuery, GetAntisenceSeqQueryVariables>(GetAntisenceSeqDocument, options);
        }
export type GetAntisenceSeqQueryHookResult = ReturnType<typeof useGetAntisenceSeqQuery>;
export type GetAntisenceSeqLazyQueryHookResult = ReturnType<typeof useGetAntisenceSeqLazyQuery>;
export type GetAntisenceSeqSuspenseQueryHookResult = ReturnType<typeof useGetAntisenceSeqSuspenseQuery>;
export type GetAntisenceSeqQueryResult = Apollo.QueryResult<GetAntisenceSeqQuery, GetAntisenceSeqQueryVariables>;
export const GetSessionDataDocument = gql`
    query getSessionData($product: ConfiguratorProductInput!) {
  getSessionData(product: $product) {
    ...TubeDataFromSession
  }
}
    ${TubeDataFromSessionFragmentDoc}`;
export type GetSessionDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSessionDataQuery, GetSessionDataQueryVariables>, 'query'> & ({ variables: GetSessionDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSessionDataComponent = (props: GetSessionDataComponentProps) => (
      <ApolloReactComponents.Query<GetSessionDataQuery, GetSessionDataQueryVariables> query={GetSessionDataDocument} {...props} />
    );
    

/**
 * __useGetSessionDataQuery__
 *
 * To run a query within a React component, call `useGetSessionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionDataQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useGetSessionDataQuery(baseOptions: Apollo.QueryHookOptions<GetSessionDataQuery, GetSessionDataQueryVariables> & ({ variables: GetSessionDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionDataQuery, GetSessionDataQueryVariables>(GetSessionDataDocument, options);
      }
export function useGetSessionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionDataQuery, GetSessionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionDataQuery, GetSessionDataQueryVariables>(GetSessionDataDocument, options);
        }
export function useGetSessionDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSessionDataQuery, GetSessionDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSessionDataQuery, GetSessionDataQueryVariables>(GetSessionDataDocument, options);
        }
export type GetSessionDataQueryHookResult = ReturnType<typeof useGetSessionDataQuery>;
export type GetSessionDataLazyQueryHookResult = ReturnType<typeof useGetSessionDataLazyQuery>;
export type GetSessionDataSuspenseQueryHookResult = ReturnType<typeof useGetSessionDataSuspenseQuery>;
export type GetSessionDataQueryResult = Apollo.QueryResult<GetSessionDataQuery, GetSessionDataQueryVariables>;
export const SpecificationCalculationDocument = gql`
    query SpecificationCalculation($input: SpecificationsInput!, $product: ConfiguratorProductInput!) {
  getSpecificationCalculation(input: $input, product: $product) {
    errorValues {
      valid
      validationType
      key
    }
    calculatedValues {
      amount
      maxConcentration
      scale
      daughterPlateRange
      maxAmount
      maxVolume
      minVolume
    }
  }
}
    `;
export type SpecificationCalculationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SpecificationCalculationQuery, SpecificationCalculationQueryVariables>, 'query'> & ({ variables: SpecificationCalculationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SpecificationCalculationComponent = (props: SpecificationCalculationComponentProps) => (
      <ApolloReactComponents.Query<SpecificationCalculationQuery, SpecificationCalculationQueryVariables> query={SpecificationCalculationDocument} {...props} />
    );
    

/**
 * __useSpecificationCalculationQuery__
 *
 * To run a query within a React component, call `useSpecificationCalculationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecificationCalculationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecificationCalculationQuery({
 *   variables: {
 *      input: // value for 'input'
 *      product: // value for 'product'
 *   },
 * });
 */
export function useSpecificationCalculationQuery(baseOptions: Apollo.QueryHookOptions<SpecificationCalculationQuery, SpecificationCalculationQueryVariables> & ({ variables: SpecificationCalculationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpecificationCalculationQuery, SpecificationCalculationQueryVariables>(SpecificationCalculationDocument, options);
      }
export function useSpecificationCalculationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpecificationCalculationQuery, SpecificationCalculationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpecificationCalculationQuery, SpecificationCalculationQueryVariables>(SpecificationCalculationDocument, options);
        }
export function useSpecificationCalculationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SpecificationCalculationQuery, SpecificationCalculationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SpecificationCalculationQuery, SpecificationCalculationQueryVariables>(SpecificationCalculationDocument, options);
        }
export type SpecificationCalculationQueryHookResult = ReturnType<typeof useSpecificationCalculationQuery>;
export type SpecificationCalculationLazyQueryHookResult = ReturnType<typeof useSpecificationCalculationLazyQuery>;
export type SpecificationCalculationSuspenseQueryHookResult = ReturnType<typeof useSpecificationCalculationSuspenseQuery>;
export type SpecificationCalculationQueryResult = Apollo.QueryResult<SpecificationCalculationQuery, SpecificationCalculationQueryVariables>;
export const GetPlatePriceCallDocument = gql`
    query getPlatePriceCall($product: ConfiguratorProductInput!) {
  getPlatePriceCall(product: $product) {
    ...PlatesPriceResponse
  }
}
    ${PlatesPriceResponseFragmentDoc}`;
export type GetPlatePriceCallComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPlatePriceCallQuery, GetPlatePriceCallQueryVariables>, 'query'> & ({ variables: GetPlatePriceCallQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetPlatePriceCallComponent = (props: GetPlatePriceCallComponentProps) => (
      <ApolloReactComponents.Query<GetPlatePriceCallQuery, GetPlatePriceCallQueryVariables> query={GetPlatePriceCallDocument} {...props} />
    );
    

/**
 * __useGetPlatePriceCallQuery__
 *
 * To run a query within a React component, call `useGetPlatePriceCallQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatePriceCallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatePriceCallQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useGetPlatePriceCallQuery(baseOptions: Apollo.QueryHookOptions<GetPlatePriceCallQuery, GetPlatePriceCallQueryVariables> & ({ variables: GetPlatePriceCallQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatePriceCallQuery, GetPlatePriceCallQueryVariables>(GetPlatePriceCallDocument, options);
      }
export function useGetPlatePriceCallLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatePriceCallQuery, GetPlatePriceCallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatePriceCallQuery, GetPlatePriceCallQueryVariables>(GetPlatePriceCallDocument, options);
        }
export function useGetPlatePriceCallSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlatePriceCallQuery, GetPlatePriceCallQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlatePriceCallQuery, GetPlatePriceCallQueryVariables>(GetPlatePriceCallDocument, options);
        }
export type GetPlatePriceCallQueryHookResult = ReturnType<typeof useGetPlatePriceCallQuery>;
export type GetPlatePriceCallLazyQueryHookResult = ReturnType<typeof useGetPlatePriceCallLazyQuery>;
export type GetPlatePriceCallSuspenseQueryHookResult = ReturnType<typeof useGetPlatePriceCallSuspenseQuery>;
export type GetPlatePriceCallQueryResult = Apollo.QueryResult<GetPlatePriceCallQuery, GetPlatePriceCallQueryVariables>;
export const GetProductInformationDocument = gql`
    query getProductInformation($input: getProductInformationInput!) {
  getProductInformation(input: $input) {
    productType
    typeCode
    packageType
    instructions
    displayName
    brand
    shippingOptions
    companionProducts
    currencyFormat
    decimalSeparator
    thousandSeparator
    prefixCurrecny
    thousandSpacing
  }
}
    `;
export type GetProductInformationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProductInformationQuery, GetProductInformationQueryVariables>, 'query'> & ({ variables: GetProductInformationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetProductInformationComponent = (props: GetProductInformationComponentProps) => (
      <ApolloReactComponents.Query<GetProductInformationQuery, GetProductInformationQueryVariables> query={GetProductInformationDocument} {...props} />
    );
    

/**
 * __useGetProductInformationQuery__
 *
 * To run a query within a React component, call `useGetProductInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductInformationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProductInformationQuery(baseOptions: Apollo.QueryHookOptions<GetProductInformationQuery, GetProductInformationQueryVariables> & ({ variables: GetProductInformationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductInformationQuery, GetProductInformationQueryVariables>(GetProductInformationDocument, options);
      }
export function useGetProductInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductInformationQuery, GetProductInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductInformationQuery, GetProductInformationQueryVariables>(GetProductInformationDocument, options);
        }
export function useGetProductInformationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductInformationQuery, GetProductInformationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductInformationQuery, GetProductInformationQueryVariables>(GetProductInformationDocument, options);
        }
export type GetProductInformationQueryHookResult = ReturnType<typeof useGetProductInformationQuery>;
export type GetProductInformationLazyQueryHookResult = ReturnType<typeof useGetProductInformationLazyQuery>;
export type GetProductInformationSuspenseQueryHookResult = ReturnType<typeof useGetProductInformationSuspenseQuery>;
export type GetProductInformationQueryResult = Apollo.QueryResult<GetProductInformationQuery, GetProductInformationQueryVariables>;
export const TubeEditLinkDocument = gql`
    query tubeEditLink($product: tubeEditInput) {
  tubeEditLink(product: $product) {
    ...TubeDataFromSession
  }
}
    ${TubeDataFromSessionFragmentDoc}`;
export type TubeEditLinkComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TubeEditLinkQuery, TubeEditLinkQueryVariables>, 'query'>;

    export const TubeEditLinkComponent = (props: TubeEditLinkComponentProps) => (
      <ApolloReactComponents.Query<TubeEditLinkQuery, TubeEditLinkQueryVariables> query={TubeEditLinkDocument} {...props} />
    );
    

/**
 * __useTubeEditLinkQuery__
 *
 * To run a query within a React component, call `useTubeEditLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useTubeEditLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTubeEditLinkQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useTubeEditLinkQuery(baseOptions?: Apollo.QueryHookOptions<TubeEditLinkQuery, TubeEditLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TubeEditLinkQuery, TubeEditLinkQueryVariables>(TubeEditLinkDocument, options);
      }
export function useTubeEditLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TubeEditLinkQuery, TubeEditLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TubeEditLinkQuery, TubeEditLinkQueryVariables>(TubeEditLinkDocument, options);
        }
export function useTubeEditLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TubeEditLinkQuery, TubeEditLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TubeEditLinkQuery, TubeEditLinkQueryVariables>(TubeEditLinkDocument, options);
        }
export type TubeEditLinkQueryHookResult = ReturnType<typeof useTubeEditLinkQuery>;
export type TubeEditLinkLazyQueryHookResult = ReturnType<typeof useTubeEditLinkLazyQuery>;
export type TubeEditLinkSuspenseQueryHookResult = ReturnType<typeof useTubeEditLinkSuspenseQuery>;
export type TubeEditLinkQueryResult = Apollo.QueryResult<TubeEditLinkQuery, TubeEditLinkQueryVariables>;
export const GetCrisprSessionDataDocument = gql`
    query getCrisprSessionData($product: ConfiguratorProductInput!) {
  getCrisprSessionData(product: $product) {
    ...CrisprSessionResponse
  }
}
    ${CrisprSessionResponseFragmentDoc}`;
export type GetCrisprSessionDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCrisprSessionDataQuery, GetCrisprSessionDataQueryVariables>, 'query'> & ({ variables: GetCrisprSessionDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetCrisprSessionDataComponent = (props: GetCrisprSessionDataComponentProps) => (
      <ApolloReactComponents.Query<GetCrisprSessionDataQuery, GetCrisprSessionDataQueryVariables> query={GetCrisprSessionDataDocument} {...props} />
    );
    

/**
 * __useGetCrisprSessionDataQuery__
 *
 * To run a query within a React component, call `useGetCrisprSessionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrisprSessionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrisprSessionDataQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useGetCrisprSessionDataQuery(baseOptions: Apollo.QueryHookOptions<GetCrisprSessionDataQuery, GetCrisprSessionDataQueryVariables> & ({ variables: GetCrisprSessionDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrisprSessionDataQuery, GetCrisprSessionDataQueryVariables>(GetCrisprSessionDataDocument, options);
      }
export function useGetCrisprSessionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrisprSessionDataQuery, GetCrisprSessionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrisprSessionDataQuery, GetCrisprSessionDataQueryVariables>(GetCrisprSessionDataDocument, options);
        }
export function useGetCrisprSessionDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCrisprSessionDataQuery, GetCrisprSessionDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCrisprSessionDataQuery, GetCrisprSessionDataQueryVariables>(GetCrisprSessionDataDocument, options);
        }
export type GetCrisprSessionDataQueryHookResult = ReturnType<typeof useGetCrisprSessionDataQuery>;
export type GetCrisprSessionDataLazyQueryHookResult = ReturnType<typeof useGetCrisprSessionDataLazyQuery>;
export type GetCrisprSessionDataSuspenseQueryHookResult = ReturnType<typeof useGetCrisprSessionDataSuspenseQuery>;
export type GetCrisprSessionDataQueryResult = Apollo.QueryResult<GetCrisprSessionDataQuery, GetCrisprSessionDataQueryVariables>;
export const MilliplexSearchAnalytesDocument = gql`
    query milliplexSearchAnalytes($input: String!, $product: ConfiguratorProductInput!) {
  milliplexSearchAnalytes(input: $input, product: $product) {
    requestDate
    responseDate
    count
    version
    term
    termCount
    assays {
      panelId
      panelName
      assayType
      customPremixedAvailable
      requireSample
      researchAreaOracle
      species
      researchAreas
      type
      listSampleType
      customPremixSelection
      spaceSaverSelection
      decisionTableVer
      listSearchResultModelErrors {
        key
        value
      }
      listWarnings {
        key
        value
      }
      listAnalytes
      selectedAnalytes
      price
      allAnalytesSelected
      mutualAnalytesList
      analytes
      quantity
      material
      spaceSaver
      name
      sampleType
      id
      productTotal
    }
  }
}
    `;
export type MilliplexSearchAnalytesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MilliplexSearchAnalytesQuery, MilliplexSearchAnalytesQueryVariables>, 'query'> & ({ variables: MilliplexSearchAnalytesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MilliplexSearchAnalytesComponent = (props: MilliplexSearchAnalytesComponentProps) => (
      <ApolloReactComponents.Query<MilliplexSearchAnalytesQuery, MilliplexSearchAnalytesQueryVariables> query={MilliplexSearchAnalytesDocument} {...props} />
    );
    

/**
 * __useMilliplexSearchAnalytesQuery__
 *
 * To run a query within a React component, call `useMilliplexSearchAnalytesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMilliplexSearchAnalytesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMilliplexSearchAnalytesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      product: // value for 'product'
 *   },
 * });
 */
export function useMilliplexSearchAnalytesQuery(baseOptions: Apollo.QueryHookOptions<MilliplexSearchAnalytesQuery, MilliplexSearchAnalytesQueryVariables> & ({ variables: MilliplexSearchAnalytesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MilliplexSearchAnalytesQuery, MilliplexSearchAnalytesQueryVariables>(MilliplexSearchAnalytesDocument, options);
      }
export function useMilliplexSearchAnalytesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MilliplexSearchAnalytesQuery, MilliplexSearchAnalytesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MilliplexSearchAnalytesQuery, MilliplexSearchAnalytesQueryVariables>(MilliplexSearchAnalytesDocument, options);
        }
export function useMilliplexSearchAnalytesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MilliplexSearchAnalytesQuery, MilliplexSearchAnalytesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MilliplexSearchAnalytesQuery, MilliplexSearchAnalytesQueryVariables>(MilliplexSearchAnalytesDocument, options);
        }
export type MilliplexSearchAnalytesQueryHookResult = ReturnType<typeof useMilliplexSearchAnalytesQuery>;
export type MilliplexSearchAnalytesLazyQueryHookResult = ReturnType<typeof useMilliplexSearchAnalytesLazyQuery>;
export type MilliplexSearchAnalytesSuspenseQueryHookResult = ReturnType<typeof useMilliplexSearchAnalytesSuspenseQuery>;
export type MilliplexSearchAnalytesQueryResult = Apollo.QueryResult<MilliplexSearchAnalytesQuery, MilliplexSearchAnalytesQueryVariables>;
export const GetCrisprPriceCallDocument = gql`
    query getCrisprPriceCall($product: ConfiguratorProductInput!) {
  getCrisprPriceCall(product: $product) {
    ...CrisprPriceResponse
  }
}
    ${CrisprPriceResponseFragmentDoc}`;
export type GetCrisprPriceCallComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCrisprPriceCallQuery, GetCrisprPriceCallQueryVariables>, 'query'> & ({ variables: GetCrisprPriceCallQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetCrisprPriceCallComponent = (props: GetCrisprPriceCallComponentProps) => (
      <ApolloReactComponents.Query<GetCrisprPriceCallQuery, GetCrisprPriceCallQueryVariables> query={GetCrisprPriceCallDocument} {...props} />
    );
    

/**
 * __useGetCrisprPriceCallQuery__
 *
 * To run a query within a React component, call `useGetCrisprPriceCallQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrisprPriceCallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrisprPriceCallQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useGetCrisprPriceCallQuery(baseOptions: Apollo.QueryHookOptions<GetCrisprPriceCallQuery, GetCrisprPriceCallQueryVariables> & ({ variables: GetCrisprPriceCallQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrisprPriceCallQuery, GetCrisprPriceCallQueryVariables>(GetCrisprPriceCallDocument, options);
      }
export function useGetCrisprPriceCallLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrisprPriceCallQuery, GetCrisprPriceCallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrisprPriceCallQuery, GetCrisprPriceCallQueryVariables>(GetCrisprPriceCallDocument, options);
        }
export function useGetCrisprPriceCallSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCrisprPriceCallQuery, GetCrisprPriceCallQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCrisprPriceCallQuery, GetCrisprPriceCallQueryVariables>(GetCrisprPriceCallDocument, options);
        }
export type GetCrisprPriceCallQueryHookResult = ReturnType<typeof useGetCrisprPriceCallQuery>;
export type GetCrisprPriceCallLazyQueryHookResult = ReturnType<typeof useGetCrisprPriceCallLazyQuery>;
export type GetCrisprPriceCallSuspenseQueryHookResult = ReturnType<typeof useGetCrisprPriceCallSuspenseQuery>;
export type GetCrisprPriceCallQueryResult = Apollo.QueryResult<GetCrisprPriceCallQuery, GetCrisprPriceCallQueryVariables>;
export const GetAntiseraSessionDataDocument = gql`
    query getAntiseraSessionData($product: ConfiguratorProductInput!) {
  getAntiseraSessionData(product: $product) {
    ...AntiseraSessionDataResponse
  }
}
    ${AntiseraSessionDataResponseFragmentDoc}`;
export type GetAntiseraSessionDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAntiseraSessionDataQuery, GetAntiseraSessionDataQueryVariables>, 'query'> & ({ variables: GetAntiseraSessionDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAntiseraSessionDataComponent = (props: GetAntiseraSessionDataComponentProps) => (
      <ApolloReactComponents.Query<GetAntiseraSessionDataQuery, GetAntiseraSessionDataQueryVariables> query={GetAntiseraSessionDataDocument} {...props} />
    );
    

/**
 * __useGetAntiseraSessionDataQuery__
 *
 * To run a query within a React component, call `useGetAntiseraSessionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAntiseraSessionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAntiseraSessionDataQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useGetAntiseraSessionDataQuery(baseOptions: Apollo.QueryHookOptions<GetAntiseraSessionDataQuery, GetAntiseraSessionDataQueryVariables> & ({ variables: GetAntiseraSessionDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAntiseraSessionDataQuery, GetAntiseraSessionDataQueryVariables>(GetAntiseraSessionDataDocument, options);
      }
export function useGetAntiseraSessionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAntiseraSessionDataQuery, GetAntiseraSessionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAntiseraSessionDataQuery, GetAntiseraSessionDataQueryVariables>(GetAntiseraSessionDataDocument, options);
        }
export function useGetAntiseraSessionDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAntiseraSessionDataQuery, GetAntiseraSessionDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAntiseraSessionDataQuery, GetAntiseraSessionDataQueryVariables>(GetAntiseraSessionDataDocument, options);
        }
export type GetAntiseraSessionDataQueryHookResult = ReturnType<typeof useGetAntiseraSessionDataQuery>;
export type GetAntiseraSessionDataLazyQueryHookResult = ReturnType<typeof useGetAntiseraSessionDataLazyQuery>;
export type GetAntiseraSessionDataSuspenseQueryHookResult = ReturnType<typeof useGetAntiseraSessionDataSuspenseQuery>;
export type GetAntiseraSessionDataQueryResult = Apollo.QueryResult<GetAntiseraSessionDataQuery, GetAntiseraSessionDataQueryVariables>;
export const GetMilliplexSessionDataDocument = gql`
    query getMilliplexSessionData($product: ConfiguratorProductInput!) {
  getMilliplexSessionData(product: $product) {
    ...MilliplexSessionDataResponse
  }
}
    ${MilliplexSessionDataResponseFragmentDoc}`;
export type GetMilliplexSessionDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMilliplexSessionDataQuery, GetMilliplexSessionDataQueryVariables>, 'query'> & ({ variables: GetMilliplexSessionDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMilliplexSessionDataComponent = (props: GetMilliplexSessionDataComponentProps) => (
      <ApolloReactComponents.Query<GetMilliplexSessionDataQuery, GetMilliplexSessionDataQueryVariables> query={GetMilliplexSessionDataDocument} {...props} />
    );
    

/**
 * __useGetMilliplexSessionDataQuery__
 *
 * To run a query within a React component, call `useGetMilliplexSessionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMilliplexSessionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMilliplexSessionDataQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useGetMilliplexSessionDataQuery(baseOptions: Apollo.QueryHookOptions<GetMilliplexSessionDataQuery, GetMilliplexSessionDataQueryVariables> & ({ variables: GetMilliplexSessionDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMilliplexSessionDataQuery, GetMilliplexSessionDataQueryVariables>(GetMilliplexSessionDataDocument, options);
      }
export function useGetMilliplexSessionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMilliplexSessionDataQuery, GetMilliplexSessionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMilliplexSessionDataQuery, GetMilliplexSessionDataQueryVariables>(GetMilliplexSessionDataDocument, options);
        }
export function useGetMilliplexSessionDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMilliplexSessionDataQuery, GetMilliplexSessionDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMilliplexSessionDataQuery, GetMilliplexSessionDataQueryVariables>(GetMilliplexSessionDataDocument, options);
        }
export type GetMilliplexSessionDataQueryHookResult = ReturnType<typeof useGetMilliplexSessionDataQuery>;
export type GetMilliplexSessionDataLazyQueryHookResult = ReturnType<typeof useGetMilliplexSessionDataLazyQuery>;
export type GetMilliplexSessionDataSuspenseQueryHookResult = ReturnType<typeof useGetMilliplexSessionDataSuspenseQuery>;
export type GetMilliplexSessionDataQueryResult = Apollo.QueryResult<GetMilliplexSessionDataQuery, GetMilliplexSessionDataQueryVariables>;
export const GetSimpleAntiseraSessionDataDocument = gql`
    query getSimpleAntiseraSessionData($product: ConfiguratorProductInput!) {
  getSimpleAntiseraSessionData(product: $product) {
    ...SimpleAntiseraSessionResponse
  }
}
    ${SimpleAntiseraSessionResponseFragmentDoc}`;
export type GetSimpleAntiseraSessionDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSimpleAntiseraSessionDataQuery, GetSimpleAntiseraSessionDataQueryVariables>, 'query'> & ({ variables: GetSimpleAntiseraSessionDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSimpleAntiseraSessionDataComponent = (props: GetSimpleAntiseraSessionDataComponentProps) => (
      <ApolloReactComponents.Query<GetSimpleAntiseraSessionDataQuery, GetSimpleAntiseraSessionDataQueryVariables> query={GetSimpleAntiseraSessionDataDocument} {...props} />
    );
    

/**
 * __useGetSimpleAntiseraSessionDataQuery__
 *
 * To run a query within a React component, call `useGetSimpleAntiseraSessionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimpleAntiseraSessionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimpleAntiseraSessionDataQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useGetSimpleAntiseraSessionDataQuery(baseOptions: Apollo.QueryHookOptions<GetSimpleAntiseraSessionDataQuery, GetSimpleAntiseraSessionDataQueryVariables> & ({ variables: GetSimpleAntiseraSessionDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimpleAntiseraSessionDataQuery, GetSimpleAntiseraSessionDataQueryVariables>(GetSimpleAntiseraSessionDataDocument, options);
      }
export function useGetSimpleAntiseraSessionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimpleAntiseraSessionDataQuery, GetSimpleAntiseraSessionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimpleAntiseraSessionDataQuery, GetSimpleAntiseraSessionDataQueryVariables>(GetSimpleAntiseraSessionDataDocument, options);
        }
export function useGetSimpleAntiseraSessionDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSimpleAntiseraSessionDataQuery, GetSimpleAntiseraSessionDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSimpleAntiseraSessionDataQuery, GetSimpleAntiseraSessionDataQueryVariables>(GetSimpleAntiseraSessionDataDocument, options);
        }
export type GetSimpleAntiseraSessionDataQueryHookResult = ReturnType<typeof useGetSimpleAntiseraSessionDataQuery>;
export type GetSimpleAntiseraSessionDataLazyQueryHookResult = ReturnType<typeof useGetSimpleAntiseraSessionDataLazyQuery>;
export type GetSimpleAntiseraSessionDataSuspenseQueryHookResult = ReturnType<typeof useGetSimpleAntiseraSessionDataSuspenseQuery>;
export type GetSimpleAntiseraSessionDataQueryResult = Apollo.QueryResult<GetSimpleAntiseraSessionDataQuery, GetSimpleAntiseraSessionDataQueryVariables>;
export const BitubeEditLinkDocument = gql`
    query bitubeEditLink($product: tubeEditInput) {
  bitubeEditLink(product: $product) {
    ...BiTubeData
  }
}
    ${BiTubeDataFragmentDoc}`;
export type BitubeEditLinkComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BitubeEditLinkQuery, BitubeEditLinkQueryVariables>, 'query'>;

    export const BitubeEditLinkComponent = (props: BitubeEditLinkComponentProps) => (
      <ApolloReactComponents.Query<BitubeEditLinkQuery, BitubeEditLinkQueryVariables> query={BitubeEditLinkDocument} {...props} />
    );
    

/**
 * __useBitubeEditLinkQuery__
 *
 * To run a query within a React component, call `useBitubeEditLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useBitubeEditLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBitubeEditLinkQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useBitubeEditLinkQuery(baseOptions?: Apollo.QueryHookOptions<BitubeEditLinkQuery, BitubeEditLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BitubeEditLinkQuery, BitubeEditLinkQueryVariables>(BitubeEditLinkDocument, options);
      }
export function useBitubeEditLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BitubeEditLinkQuery, BitubeEditLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BitubeEditLinkQuery, BitubeEditLinkQueryVariables>(BitubeEditLinkDocument, options);
        }
export function useBitubeEditLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BitubeEditLinkQuery, BitubeEditLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BitubeEditLinkQuery, BitubeEditLinkQueryVariables>(BitubeEditLinkDocument, options);
        }
export type BitubeEditLinkQueryHookResult = ReturnType<typeof useBitubeEditLinkQuery>;
export type BitubeEditLinkLazyQueryHookResult = ReturnType<typeof useBitubeEditLinkLazyQuery>;
export type BitubeEditLinkSuspenseQueryHookResult = ReturnType<typeof useBitubeEditLinkSuspenseQuery>;
export type BitubeEditLinkQueryResult = Apollo.QueryResult<BitubeEditLinkQuery, BitubeEditLinkQueryVariables>;
export const GetConfContactDetailsDocument = gql`
    query getConfContactDetails($country: String) {
  getConfContactDetails(country: $country) {
    phone
    email
  }
}
    `;
export type GetConfContactDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetConfContactDetailsQuery, GetConfContactDetailsQueryVariables>, 'query'>;

    export const GetConfContactDetailsComponent = (props: GetConfContactDetailsComponentProps) => (
      <ApolloReactComponents.Query<GetConfContactDetailsQuery, GetConfContactDetailsQueryVariables> query={GetConfContactDetailsDocument} {...props} />
    );
    

/**
 * __useGetConfContactDetailsQuery__
 *
 * To run a query within a React component, call `useGetConfContactDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfContactDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfContactDetailsQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetConfContactDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetConfContactDetailsQuery, GetConfContactDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfContactDetailsQuery, GetConfContactDetailsQueryVariables>(GetConfContactDetailsDocument, options);
      }
export function useGetConfContactDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfContactDetailsQuery, GetConfContactDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfContactDetailsQuery, GetConfContactDetailsQueryVariables>(GetConfContactDetailsDocument, options);
        }
export function useGetConfContactDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConfContactDetailsQuery, GetConfContactDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConfContactDetailsQuery, GetConfContactDetailsQueryVariables>(GetConfContactDetailsDocument, options);
        }
export type GetConfContactDetailsQueryHookResult = ReturnType<typeof useGetConfContactDetailsQuery>;
export type GetConfContactDetailsLazyQueryHookResult = ReturnType<typeof useGetConfContactDetailsLazyQuery>;
export type GetConfContactDetailsSuspenseQueryHookResult = ReturnType<typeof useGetConfContactDetailsSuspenseQuery>;
export type GetConfContactDetailsQueryResult = Apollo.QueryResult<GetConfContactDetailsQuery, GetConfContactDetailsQueryVariables>;
export const CustomCrisprEditLinkDocument = gql`
    query customCrisprEditLink($product: ConfiguratorProductInput!) {
  customCrisprEditLink(product: $product) {
    ...CrisprSessionResponse
  }
}
    ${CrisprSessionResponseFragmentDoc}`;
export type CustomCrisprEditLinkComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CustomCrisprEditLinkQuery, CustomCrisprEditLinkQueryVariables>, 'query'> & ({ variables: CustomCrisprEditLinkQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CustomCrisprEditLinkComponent = (props: CustomCrisprEditLinkComponentProps) => (
      <ApolloReactComponents.Query<CustomCrisprEditLinkQuery, CustomCrisprEditLinkQueryVariables> query={CustomCrisprEditLinkDocument} {...props} />
    );
    

/**
 * __useCustomCrisprEditLinkQuery__
 *
 * To run a query within a React component, call `useCustomCrisprEditLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomCrisprEditLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomCrisprEditLinkQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useCustomCrisprEditLinkQuery(baseOptions: Apollo.QueryHookOptions<CustomCrisprEditLinkQuery, CustomCrisprEditLinkQueryVariables> & ({ variables: CustomCrisprEditLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomCrisprEditLinkQuery, CustomCrisprEditLinkQueryVariables>(CustomCrisprEditLinkDocument, options);
      }
export function useCustomCrisprEditLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomCrisprEditLinkQuery, CustomCrisprEditLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomCrisprEditLinkQuery, CustomCrisprEditLinkQueryVariables>(CustomCrisprEditLinkDocument, options);
        }
export function useCustomCrisprEditLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomCrisprEditLinkQuery, CustomCrisprEditLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomCrisprEditLinkQuery, CustomCrisprEditLinkQueryVariables>(CustomCrisprEditLinkDocument, options);
        }
export type CustomCrisprEditLinkQueryHookResult = ReturnType<typeof useCustomCrisprEditLinkQuery>;
export type CustomCrisprEditLinkLazyQueryHookResult = ReturnType<typeof useCustomCrisprEditLinkLazyQuery>;
export type CustomCrisprEditLinkSuspenseQueryHookResult = ReturnType<typeof useCustomCrisprEditLinkSuspenseQuery>;
export type CustomCrisprEditLinkQueryResult = Apollo.QueryResult<CustomCrisprEditLinkQuery, CustomCrisprEditLinkQueryVariables>;
export const SimpleAntiseraEditLinkDocument = gql`
    query simpleAntiseraEditLink($product: ConfiguratorProductInput!) {
  simpleAntiseraEditLink(product: $product) {
    ...SimpleAntiseraSessionResponse
  }
}
    ${SimpleAntiseraSessionResponseFragmentDoc}`;
export type SimpleAntiseraEditLinkComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SimpleAntiseraEditLinkQuery, SimpleAntiseraEditLinkQueryVariables>, 'query'> & ({ variables: SimpleAntiseraEditLinkQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SimpleAntiseraEditLinkComponent = (props: SimpleAntiseraEditLinkComponentProps) => (
      <ApolloReactComponents.Query<SimpleAntiseraEditLinkQuery, SimpleAntiseraEditLinkQueryVariables> query={SimpleAntiseraEditLinkDocument} {...props} />
    );
    

/**
 * __useSimpleAntiseraEditLinkQuery__
 *
 * To run a query within a React component, call `useSimpleAntiseraEditLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimpleAntiseraEditLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimpleAntiseraEditLinkQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useSimpleAntiseraEditLinkQuery(baseOptions: Apollo.QueryHookOptions<SimpleAntiseraEditLinkQuery, SimpleAntiseraEditLinkQueryVariables> & ({ variables: SimpleAntiseraEditLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimpleAntiseraEditLinkQuery, SimpleAntiseraEditLinkQueryVariables>(SimpleAntiseraEditLinkDocument, options);
      }
export function useSimpleAntiseraEditLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimpleAntiseraEditLinkQuery, SimpleAntiseraEditLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimpleAntiseraEditLinkQuery, SimpleAntiseraEditLinkQueryVariables>(SimpleAntiseraEditLinkDocument, options);
        }
export function useSimpleAntiseraEditLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimpleAntiseraEditLinkQuery, SimpleAntiseraEditLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SimpleAntiseraEditLinkQuery, SimpleAntiseraEditLinkQueryVariables>(SimpleAntiseraEditLinkDocument, options);
        }
export type SimpleAntiseraEditLinkQueryHookResult = ReturnType<typeof useSimpleAntiseraEditLinkQuery>;
export type SimpleAntiseraEditLinkLazyQueryHookResult = ReturnType<typeof useSimpleAntiseraEditLinkLazyQuery>;
export type SimpleAntiseraEditLinkSuspenseQueryHookResult = ReturnType<typeof useSimpleAntiseraEditLinkSuspenseQuery>;
export type SimpleAntiseraEditLinkQueryResult = Apollo.QueryResult<SimpleAntiseraEditLinkQuery, SimpleAntiseraEditLinkQueryVariables>;
export const AntiseraEditLinkDocument = gql`
    query antiseraEditLink($product: ConfiguratorProductInput!) {
  antiseraEditLink(product: $product) {
    ...AntiseraSessionDataResponse
  }
}
    ${AntiseraSessionDataResponseFragmentDoc}`;
export type AntiseraEditLinkComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AntiseraEditLinkQuery, AntiseraEditLinkQueryVariables>, 'query'> & ({ variables: AntiseraEditLinkQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AntiseraEditLinkComponent = (props: AntiseraEditLinkComponentProps) => (
      <ApolloReactComponents.Query<AntiseraEditLinkQuery, AntiseraEditLinkQueryVariables> query={AntiseraEditLinkDocument} {...props} />
    );
    

/**
 * __useAntiseraEditLinkQuery__
 *
 * To run a query within a React component, call `useAntiseraEditLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useAntiseraEditLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAntiseraEditLinkQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useAntiseraEditLinkQuery(baseOptions: Apollo.QueryHookOptions<AntiseraEditLinkQuery, AntiseraEditLinkQueryVariables> & ({ variables: AntiseraEditLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AntiseraEditLinkQuery, AntiseraEditLinkQueryVariables>(AntiseraEditLinkDocument, options);
      }
export function useAntiseraEditLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AntiseraEditLinkQuery, AntiseraEditLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AntiseraEditLinkQuery, AntiseraEditLinkQueryVariables>(AntiseraEditLinkDocument, options);
        }
export function useAntiseraEditLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AntiseraEditLinkQuery, AntiseraEditLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AntiseraEditLinkQuery, AntiseraEditLinkQueryVariables>(AntiseraEditLinkDocument, options);
        }
export type AntiseraEditLinkQueryHookResult = ReturnType<typeof useAntiseraEditLinkQuery>;
export type AntiseraEditLinkLazyQueryHookResult = ReturnType<typeof useAntiseraEditLinkLazyQuery>;
export type AntiseraEditLinkSuspenseQueryHookResult = ReturnType<typeof useAntiseraEditLinkSuspenseQuery>;
export type AntiseraEditLinkQueryResult = Apollo.QueryResult<AntiseraEditLinkQuery, AntiseraEditLinkQueryVariables>;
export const GetCustomOligoProductsDocument = gql`
    query getCustomOligoProducts($input: ConfiguratorProductInput!) {
  getCustomOligoProducts(input: $input) {
    products
  }
}
    `;
export type GetCustomOligoProductsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCustomOligoProductsQuery, GetCustomOligoProductsQueryVariables>, 'query'> & ({ variables: GetCustomOligoProductsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetCustomOligoProductsComponent = (props: GetCustomOligoProductsComponentProps) => (
      <ApolloReactComponents.Query<GetCustomOligoProductsQuery, GetCustomOligoProductsQueryVariables> query={GetCustomOligoProductsDocument} {...props} />
    );
    

/**
 * __useGetCustomOligoProductsQuery__
 *
 * To run a query within a React component, call `useGetCustomOligoProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomOligoProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomOligoProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCustomOligoProductsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomOligoProductsQuery, GetCustomOligoProductsQueryVariables> & ({ variables: GetCustomOligoProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomOligoProductsQuery, GetCustomOligoProductsQueryVariables>(GetCustomOligoProductsDocument, options);
      }
export function useGetCustomOligoProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomOligoProductsQuery, GetCustomOligoProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomOligoProductsQuery, GetCustomOligoProductsQueryVariables>(GetCustomOligoProductsDocument, options);
        }
export function useGetCustomOligoProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomOligoProductsQuery, GetCustomOligoProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomOligoProductsQuery, GetCustomOligoProductsQueryVariables>(GetCustomOligoProductsDocument, options);
        }
export type GetCustomOligoProductsQueryHookResult = ReturnType<typeof useGetCustomOligoProductsQuery>;
export type GetCustomOligoProductsLazyQueryHookResult = ReturnType<typeof useGetCustomOligoProductsLazyQuery>;
export type GetCustomOligoProductsSuspenseQueryHookResult = ReturnType<typeof useGetCustomOligoProductsSuspenseQuery>;
export type GetCustomOligoProductsQueryResult = Apollo.QueryResult<GetCustomOligoProductsQuery, GetCustomOligoProductsQueryVariables>;
export const GetNgsoPriceCallDocument = gql`
    query getNgsoPriceCall($product: ConfiguratorProductInput!) {
  getNgsoPriceCall(product: $product) {
    ...NgsoPriceResponse
  }
}
    ${NgsoPriceResponseFragmentDoc}`;
export type GetNgsoPriceCallComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNgsoPriceCallQuery, GetNgsoPriceCallQueryVariables>, 'query'> & ({ variables: GetNgsoPriceCallQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetNgsoPriceCallComponent = (props: GetNgsoPriceCallComponentProps) => (
      <ApolloReactComponents.Query<GetNgsoPriceCallQuery, GetNgsoPriceCallQueryVariables> query={GetNgsoPriceCallDocument} {...props} />
    );
    

/**
 * __useGetNgsoPriceCallQuery__
 *
 * To run a query within a React component, call `useGetNgsoPriceCallQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNgsoPriceCallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNgsoPriceCallQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useGetNgsoPriceCallQuery(baseOptions: Apollo.QueryHookOptions<GetNgsoPriceCallQuery, GetNgsoPriceCallQueryVariables> & ({ variables: GetNgsoPriceCallQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNgsoPriceCallQuery, GetNgsoPriceCallQueryVariables>(GetNgsoPriceCallDocument, options);
      }
export function useGetNgsoPriceCallLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNgsoPriceCallQuery, GetNgsoPriceCallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNgsoPriceCallQuery, GetNgsoPriceCallQueryVariables>(GetNgsoPriceCallDocument, options);
        }
export function useGetNgsoPriceCallSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNgsoPriceCallQuery, GetNgsoPriceCallQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNgsoPriceCallQuery, GetNgsoPriceCallQueryVariables>(GetNgsoPriceCallDocument, options);
        }
export type GetNgsoPriceCallQueryHookResult = ReturnType<typeof useGetNgsoPriceCallQuery>;
export type GetNgsoPriceCallLazyQueryHookResult = ReturnType<typeof useGetNgsoPriceCallLazyQuery>;
export type GetNgsoPriceCallSuspenseQueryHookResult = ReturnType<typeof useGetNgsoPriceCallSuspenseQuery>;
export type GetNgsoPriceCallQueryResult = Apollo.QueryResult<GetNgsoPriceCallQuery, GetNgsoPriceCallQueryVariables>;